import { Controller } from 'react-hook-form';

import { Filtering, Pagination, QInput } from '@qualio/ui-components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { QualioDocument } from '../../../api/model/document';

export type SearchFilterProps = {
  id: string;
  setSelectedDocumentsMap?: (selected: Map<number, QualioDocument>) => void;
};
export const SearchFilter = ({
  id,
  setSelectedDocumentsMap,
}: SearchFilterProps) => {
  const { t } = useTranslation();
  const { control } = Filtering.useFilteringForm();
  const filtering = Filtering.useFiltering();
  const pagination = Pagination.usePaginationMaybe();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('query');

  useEffect(() => {
    pagination?.setPageIndex(0);
    // Can't have `paginaton` as a dependency or else pagination will not work
    // eslint-disable-next-line
  }, [searchQuery]);

  return (
    <Controller
      name="Search"
      control={control}
      render={({ field: { onChange, value } }) => {
        const handleChange = (e: any) => {
          onChange(e);
          filtering.setSearchTerm(e.target.value);
          // reset selection in workspace
          if (setSelectedDocumentsMap) {
            setSelectedDocumentsMap(new Map());
          }
        };
        return (
          <QInput
            iconLeftName="Search"
            onChange={handleChange}
            placeholder={t('forms.search')}
            value={searchQuery ?? ''}
            data-cy={`${id}-search`}
          />
        );
      }}
    />
  );
};
